/**
 * 表格转码-字典
 */
export const FORMAT_TABLE_DICT = 'dict'
/**
 * 表格转码-角色
 */
export const FORMAT_TABLE_ROLE = 'role'
/**
 * 表格转码-日期
 */
export const FORMAT_TABLE_DATE = 'date'
/**
 * 表格转码-整数
 */
export const FORMAT_TABLE_INTEGER = 'int'
/**
 * 表格转码-小数
 */
export const FORMAT_TABLE_DECIMAL = 'decimal'



// WEBPACK FOOTER //
// ./src/constants/DataTypeConstants.js